var map = {
	"./Crude Oil.png": 776,
	"./Group 1317.png": 777,
	"./Group 9786.png": 685,
	"./India.png": 778,
	"./Liqural-Logo.png": 326,
	"./Logo_white.png": 779,
	"./PayPalLogo.png": 646,
	"./Subtraction1.png": 648,
	"./ai/ai-12.png": 706,
	"./ai/analysis-ai.png": 707,
	"./ai/doc-inti-2.png": 708,
	"./ai/kn-base-2.png": 709,
	"./algorithm-ai-2.png": 780,
	"./algorithm-ai-3.png": 781,
	"./algorithm-ai.png": 782,
	"./algorithm.png": 783,
	"./api-logo.png": 784,
	"./auth-aside.png": 785,
	"./auth/BG.png": 786,
	"./auth/Illustration.png": 787,
	"./auth/bottomShape.png": 788,
	"./auth/topShape.png": 789,
	"./avatar/NoPath (2).png": 790,
	"./avatar/NoPath (3).png": 791,
	"./avatar/NoPath (4).png": 792,
	"./avatar/NoPath.png": 193,
	"./avatar/chat-auth.png": 627,
	"./avatar/profileImage.png": 686,
	"./avatar/t1.png": 793,
	"./avatar/team-1.png": 794,
	"./banner/1.png": 687,
	"./banner/10.png": 795,
	"./banner/11.png": 796,
	"./banner/12.png": 797,
	"./banner/13.png": 798,
	"./banner/2.png": 688,
	"./banner/3.png": 689,
	"./banner/4.png": 690,
	"./banner/5.png": 691,
	"./banner/6.png": 692,
	"./banner/8.png": 650,
	"./banner/9.png": 693,
	"./banner/banner-1.png": 799,
	"./banner/banner-2.png": 800,
	"./banner/banner-3.png": 801,
	"./banner/banner-4.png": 802,
	"./banner/card-banner-1.png": 694,
	"./banner/card-banner-2.png": 695,
	"./banner/cta-banner-1.png": 696,
	"./banner/cta-banner-2.png": 697,
	"./banner/report-1.png": 803,
	"./banner/report-2.png": 804,
	"./barcode.png": 698,
	"./bell.png": 805,
	"./brain-2.png": 652,
	"./bulb.png": 806,
	"./cards-logo/american-express.png": 638,
	"./cards-logo/ms.png": 639,
	"./cards-logo/visa.png": 640,
	"./chat-assistant-2.png": 807,
	"./chat-assistant.png": 808,
	"./chat-author/g1.png": 710,
	"./chat-author/g2.png": 711,
	"./chat-author/g3.png": 712,
	"./chat-author/t10.png": 713,
	"./chat-author/t12.png": 714,
	"./chat-author/t5.png": 662,
	"./chat-author/t6.png": 663,
	"./chat-author/t7.png": 664,
	"./chat-author/t8.png": 665,
	"./chat-author/t9.png": 715,
	"./chat-author/w.png": 716,
	"./checkmark.png": 809,
	"./code_icon-icons.com_73620.png": 622,
	"./cs.png": 657,
	"./customer-service.png": 658,
	"./dalle-1.png": 810,
	"./dalle-2.png": 811,
	"./dark.png": 500,
	"./dashboard-setup.png": 812,
	"./data-not-available.png": 684,
	"./doc-ai.png": 699,
	"./email/1.png": 676,
	"./email/2.png": 647,
	"./email/3.png": 677,
	"./email/4.png": 678,
	"./files/jpg.png": 666,
	"./files/pdf.png": 667,
	"./files/png.png": 668,
	"./files/psd.png": 669,
	"./files/zip.png": 670,
	"./flag/english.png": 501,
	"./flag/germany.png": 502,
	"./flag/spain.png": 503,
	"./flag/turkey.png": 504,
	"./flag/turky.png": 813,
	"./fundamental.png": 814,
	"./fundamentals-2.png": 815,
	"./gallery/1.png": 816,
	"./gallery/10.png": 817,
	"./gallery/11.png": 818,
	"./gallery/12.png": 819,
	"./gallery/2.png": 820,
	"./gallery/3.png": 821,
	"./gallery/4.png": 822,
	"./gallery/5.png": 823,
	"./gallery/6.png": 824,
	"./gallery/7.png": 825,
	"./gallery/8.png": 826,
	"./gallery/9.png": 827,
	"./google.png": 659,
	"./icon/007-microphone-1.png": 505,
	"./icon/010-home.png": 506,
	"./icon/013-document-1.png": 507,
	"./icon/014-document.png": 508,
	"./icon/015-color-palette.png": 509,
	"./icon/017-video-camera.png": 510,
	"./icon/image.png": 442,
	"./icon/label.png": 511,
	"./icon/quote.png": 446,
	"./knowledgebase/wp-research.png": 700,
	"./light.png": 512,
	"./logo.png": 828,
	"./ltr.png": 513,
	"./map/mpc.png": 679,
	"./market-relation-icon.png": 829,
	"./mop.png": 830,
	"./payment-pay.png": 831,
	"./products/1.png": 641,
	"./products/10.png": 832,
	"./products/11.png": 833,
	"./products/12.png": 834,
	"./products/2.png": 835,
	"./products/3.png": 836,
	"./products/4.png": 837,
	"./products/5.png": 838,
	"./products/6.png": 839,
	"./products/7.png": 840,
	"./products/8.png": 841,
	"./products/9.png": 842,
	"./products/electronics/1.png": 843,
	"./products/electronics/2.png": 844,
	"./products/electronics/3.png": 845,
	"./products/electronics/4.png": 846,
	"./products/electronics/5.png": 847,
	"./profile/cover-img.png": 660,
	"./profile/post/165.png": 848,
	"./profile/post/506.png": 849,
	"./profile/post/70.png": 850,
	"./profile/post/907.png": 851,
	"./profile/post/brightland_3744.png": 852,
	"./profile/post/postImage.png": 853,
	"./rtl.png": 514,
	"./sampleCards/1.png": 717,
	"./sampleCards/10.png": 718,
	"./sampleCards/11.png": 719,
	"./sampleCards/12.png": 720,
	"./sampleCards/13.png": 721,
	"./sampleCards/2.png": 722,
	"./sampleCards/3.png": 723,
	"./sampleCards/4.png": 724,
	"./sampleCards/5.png": 725,
	"./sampleCards/6.png": 726,
	"./sampleCards/7.png": 727,
	"./sampleCards/8.png": 728,
	"./sampleCards/9.png": 729,
	"./sampleCards/card-bg.png": 730,
	"./sellers/1.png": 854,
	"./sellers/2.png": 855,
	"./sellers/3.png": 856,
	"./sellers/4.png": 857,
	"./sellers/5.png": 858,
	"./sellers/6.png": 859,
	"./sellers/7.png": 860,
	"./sellers/8.png": 861,
	"./sellers/9.png": 862,
	"./server-crash-2.png": 649,
	"./server-crash.png": 863,
	"./shape-1.png": 864,
	"./side-paper.png": 701,
	"./side.png": 515,
	"./small-logo.png": 865,
	"./support-1.png": 866,
	"./support-icon-2.png": 867,
	"./support-icon-3.png": 868,
	"./support-img.png": 869,
	"./support.png": 870,
	"./technical.png": 871,
	"./top.png": 516,
	"./trial.png": 872,
	"./users/1.png": 623,
	"./users/10.png": 731,
	"./users/11.png": 732,
	"./users/12.png": 733,
	"./users/13.png": 734,
	"./users/2.png": 634,
	"./users/3.png": 631,
	"./users/4.png": 632,
	"./users/5.png": 633,
	"./users/6.png": 643,
	"./users/7.png": 644,
	"./users/8.png": 735,
	"./users/cover/1.png": 736,
	"./users/cover/10.png": 737,
	"./users/cover/11.png": 738,
	"./users/cover/12.png": 739,
	"./users/cover/13.png": 740,
	"./users/cover/14.png": 741,
	"./users/cover/15.png": 742,
	"./users/cover/2.png": 743,
	"./users/cover/3.png": 744,
	"./users/cover/4.png": 745,
	"./users/cover/5.png": 746,
	"./users/cover/6.png": 747,
	"./users/cover/7.png": 748,
	"./users/cover/8.png": 749,
	"./users/cover/9.png": 750,
	"./warning-2.png": 661,
	"./welcome-person.png": 873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1124;